<div class="g-ui-grid-page">
  <div class="g-ui-grid-page__grid">
    <app-ui-grid [uiGridOptions]="gridOptions" (focusedRowChanged)="focusedRowChanged($event)" [shouldChangeViewportWidth]="findingsSideDrawerService.isDrawerOpen()"></app-ui-grid>
  </div>
</div>
